<script setup lang="ts">
import type { AlbumType } from '@/composables/album/album'
import { onMounted, ref, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { auditModeShow } from '@/utils/util'
import 'animate.css'

const { t } = useI18n()

// script setup
const model = defineModel<string>({ default: 'waterfall' })

interface MediaOption {
  key: string
  name: string
}

const AlbumOptions: Ref<Array<MediaOption>> = ref([
  { key: 'all', name: t('album.media_all'), icon: 'i-icon-park-solid:waterfalls-h' },
  { key: 'photo', name: t('album.media_photo'), icon: 'i-material-symbols:perm-media-outline-rounded' },
  { key: 'video', name: t('album.media_video'), icon: 'i-bx:sort-up' },
  { key: 'audio', name: t('album.media_audio'), icon: 'i-bx:sort-up' }
])

onMounted(() => {})
</script>

<template>
  <div relative bg-transparent rounded-full flex="~ row" items-center h-32px select-none justify-center overflow-hidden>
    <div
      v-for="(item, index) in AlbumOptions"
      :key="item.key"
      flex="~ row"
      items-center
      justify-center
      pr-3
      py-1
      :class="item.key === model ? '!text-theme-dark font-semibold' : '!text-theme-gray'"
      cursor-pointer
      @click="model = item.key as AlbumType">
      {{ item.name }}
    </div>
  </div>
</template>
